module.exports = "data:image/gif;base64,R0lGODlhEAAOAMIDAJdaH+C6eP/inq1zLf/////Sg59oJMOHNCwAAAAAEAAOAAADNki63P7vyAPXYBcewUsIk8RQFalsXKoCmOoKmTK8akwYRa7vBgPswAJrARgEdcOFYclsVp6EBAA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/treeview/folder-closed.gif
// module id = 1970
// module chunks = 2